import { render, staticRenderFns } from "./SelectPlan.vue?vue&type=template&id=6190ce23&scoped=true&"
import script from "./SelectPlan.vue?vue&type=script&lang=ts&"
export * from "./SelectPlan.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPlan.vue?vue&type=style&index=0&id=6190ce23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6190ce23",
  null
  
)

export default component.exports